import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React from 'react';
import { useTranslation, withTranslation } from 'react-i18next';

const TablaUsuarios = ({
  users,
  setConfigurationUsersAfterAzureSync,
  setCurrentUser,
}) => {
  const { t } = useTranslation();
  const quantityBodyTemplate = rowData => {
    return (
      <React.Fragment>
        <span className="p-column-title">{t('Correo')}</span>
        {rowData.correo}
      </React.Fragment>
    );
  };
  const nameBodyTemplate = rowData => {
    return (
      <React.Fragment>
        <span className="p-column-title">{t('Nombre')}</span>
        {rowData.nombre}
      </React.Fragment>
    );
  };
  const rolBodyTemplate = rowData => {
    return (
      <React.Fragment>
        <span className="p-column-title">{t('Rol')}</span>
        {rowData.rol}
      </React.Fragment>
    );
  };

  const renderHeader = () => (
    <div className="table-header">
      {t('Listado de Usuarios')}
      <Button
        type="button"
        className="p-link layout-profile-link"
        onClick={setConfigurationUsersAfterAzureSync}
      >
        <i className="pi pi-replay"></i>
        <label className="marginLeft10px">{t('Sincronizar Usuarios')}</label>
      </Button>
    </div>
  );

  return (
    <div className="datatable-responsive-demo">
      <div className="card"></div>
      <DataTable
        value={users}
        selected="0"
        className="p-datatable-responsive-demo roboto"
        onSelectionChange={e => setCurrentUser(e.value)}
        selectionMode="single"
        dataKey="id"
        header={renderHeader()}
        resizableColumns
        columnResizeMode="fit"
        paginator
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate=""
        rows={10}
        rowsPerPageOptions={[10, 20, 50]}
      >
        <Column
          field="nombre"
          header={t('Nombre')}
          body={nameBodyTemplate}
          style={{ width: '30%' }}
          sortable
        ></Column>
        <Column
          field="rol"
          header={t('Rol')}
          style={{ width: '20%' }}
          body={rolBodyTemplate}
          sortable
        ></Column>
        <Column
          field="correo"
          header={t('Correo')}
          body={quantityBodyTemplate}
          sortable
        ></Column>
      </DataTable>
    </div>
  );
};

export default withTranslation('translations')(TablaUsuarios);
